import { Box, useTheme } from '@mui/material';
import React from 'react';
import FontAwesome from 'react-fontawesome';

import DropzoneOverlay from './DropzoneOverlay';

const DOCUMENT_PREVIEW_IMAGE_MARGIN_RIGHT = 1;

interface DropzoneInnerProps {
  children: (props: any) => any;
  preview?: string;
  encodingFormat?: string;
  fileName?: string;
  isDragActive: boolean;
}

const DropzoneInner = ({ children, fileName, isDragActive, preview }: DropzoneInnerProps): JSX.Element => {
  const theme = useTheme();

  if (preview) {
    return children(
      <Box
        sx={{
          fontSize: '1rem',
        }}
      >
        <Box
          component={FontAwesome}
          name="file"
          sx={{
            color: theme.palette.primary.main,
            paddingRight: theme.spacing(DOCUMENT_PREVIEW_IMAGE_MARGIN_RIGHT),
          }}
        />
        <Box
          component="span"
          sx={{
            color: theme.palette.text.primary,
          }}
        >
          {fileName}
        </Box>
      </Box>,
    );
  }

  return children(<DropzoneOverlay isDragActive={isDragActive} />);
};

export default DropzoneInner;
